<app-page-header Heading="Scheduler" Description="">
    <div class="btn btn-sm btn-primary" (click)="openAlertSchedularForm()" [ariaDisabled]="isLoading">New Scheduler</div>
</app-page-header>

<!-- <app-pagination [EnablePageSize]="true" [rowData]="schedularsList" (pageSizeChanged)="handlePageSizeChange($event)">
</app-pagination> -->

<ng-container *ngIf="isLoading; else schedulersListTableContent">
    <div class="card mb-1">
        <div class="card-header d-flex align-items-center">
            <ngx-skeleton-loader count="1" width="120px" height="20px"></ngx-skeleton-loader>
            <span class="ml-2">
                <ngx-skeleton-loader count="1" width="150px" height="16px"></ngx-skeleton-loader>
            </span>
        </div>
        <div class="card-body">
            <ngx-skeleton-loader count="3" width="100%" height="14px" style="margin-bottom: 8px;"></ngx-skeleton-loader>
        </div>
    </div>
</ng-container>

<ng-template #schedulersListTableContent>
    <app-color-table [columns]="[
        {colName:'Name',colData:'iName'},
        {colName:'Code',colData:'iCode'},
        {colName:'Frequency',colData:'frequencyInMinutes'},
        {colName:'Scheduler Type',colData:'schedularType'},
        {colName:'Description',colData:'iDesc'},
        ]" [tableData]="this.schedularsList" [enableActionColumn]="true" [actionColumnLabel]="'Action'"
        [actionOptions]="[{actionName:'Edit',actionIcon:'fa fa-edit'},{actionName:'Delete',actionIcon:'fa fa-trash'}]"
        (actionClick)="handleActionClick($event)">
    </app-color-table>
</ng-template>


<!-- <app-pagination [EnableNavigation]="true" [rowData]="schedularsList" (pageSizeChanged)="handlePageSizeChange($event)">
</app-pagination> -->


<ng-template #alertSchedularModalContent>

    <div class="modal-header">
        <h5 class="modal-title">New Scheduler</h5>
        <button type="button" class="btn-close" (click)="addAlertSchedularModal.close()"></button>
    </div>
    <div class="modal-body">
        <form [formGroup]="alertSchedularForm">

            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="aName">Name</label><span style="color: red;">*</span>
                        <input type="text" class="form-control form-control-sm mt-1"
                            [formControl]="alertSchedularForm.controls.aName" placeholder="Name">
                        <app-form-errors [control]="alertSchedularForm.controls.aName"></app-form-errors>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="aCode">Code</label>
                        <input type="text" class="form-control form-control-sm mt-1"
                            [formControl]="alertSchedularForm.controls.aCode" placeholder="Code">
                    </div>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="aFreq">Frequency (in minutes)</label><span style="color: red;">*</span>
                        <input type="number" class="form-control form-control-sm mt-1"
                            [formControl]="alertSchedularForm.controls.aFreq" placeholder="Frequency">
                        <app-form-errors [control]="alertSchedularForm.controls.aFreq"></app-form-errors>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="sType">Scheduler Type</label><span style="color: red;">*</span>
                        <app-valuelist-selector [control]="alertSchedularForm.controls.sType" [vlCode]="'ANNST'" (onChange)="onSchedulerTypeChange($event)"
                            [placeholder]="'Scheduler Type'">
                        </app-valuelist-selector>
                        
                        <app-form-errors [control]="alertSchedularForm.controls.sType"></app-form-errors>
                    </div>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="aDesc">Description</label>
                        <textarea class="form-control form-control-sm mt-1"
                            [formControl]="alertSchedularForm.controls.aDesc" placeholder="Description"></textarea>
                    </div>
                </div>
            </div>

        </form>
    </div>
    <div class="modal-footer mt-3">
        <button type="button" class="btn btn-primary" (click)="submitAlertSchedularForm()" [disabled]="isLoading">
            <ng-container *ngIf="!isLoading; else savingButton">
                Save
            </ng-container>
            <ng-template #savingButton>
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Saving...
            </ng-template>
        </button>
        <button type="button" class="btn btn-secondary" (click)="addAlertSchedularModal.close()">Close</button>
    </div>
</ng-template>